/* eslint-disable */
import React, { useState, useEffect } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Stack, Card, TextField, IconButton, Grid } from '@material-ui/core';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/Delete';
import { ToastContainer, toast } from 'react-toastify';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';

export const CustomPickingTableTable = ({ cropData, setCropData, setPikingsDetails, setPickingTableError }) => {
    const [pickingTable, setPickingTable] = useState([]);
    const [isMaxEror, setIsMaxEror] = useState({});
    const [maxErrorMsg, setMaxErrorMsg] = useState({});
    const [isMinEror, setIsMinEror] = useState({});
    const [minErrorMsg, setMinErrorMsg] = useState({});
    const [pickingData, setPickingData] = useState({
        noOfPickings: 1
    });

    useEffect(() => {
        generatePickingTable()
    }, [pickingData.noOfPickings]);

    function handlePickingChange(e) {
        const target = e.target;
        const value = target.value

        setPickingData({
            ...pickingData,
            [e.target.name]: value
        });
    }

    function generatePickingTable() {
        if (pickingData.noOfPickings <= 60) {
            const index2 = pickingTable.length;
            const index3 = parseInt(pickingData.noOfPickings) - parseInt(index2);
            const index4 = index3 + index2

            var array = [...pickingTable];
            for (let index = index2; index < index4; index++) {
                let model = {
                    rowIndex: index,
                    picking: index == 0 ? index + 1 + 'st'
                        : index == 1 ? index + 1 + 'nd'
                            : index == 2 ? index + 1 + 'rd'
                                : index + 1 + 'th',
                    quantity: 0,
                    date: new Date().toISOString().split('T')[0]
                };
                checkQuntityValue(model.quantity, index)
                array.push(model);
            }
            var array2 = [...array];
            array2.sort((a, b) => a.date > b.date ? 1 : -1);
            for (let i = 0; i < array2.length; i++) {
                array2[i] = {
                    ...array2[i],
                    rowIndex: i,
                    quantity: array2[i].quantity,
                    picking: i == 0 ? i + 1 + 'st'
                        : i == 1 ? i + 1 + 'nd'
                            : i == 2 ? i + 1 + 'rd'
                                : i + 1 + 'th',
                    date: array2[i].date
                }
                checkQuntityValue(array2[i].quantity, i)
            }
            setPickingTable(array2)
        }
    }

    function handleDelete(e, rowIndex) {
        var array = [...pickingTable];
        if (array.length > 1) {
            var index = array.findIndex(obj => obj.rowIndex === rowIndex);
            array.splice(index, 1);

            for (let i = 0; i < array.length; i++) {
                array[i] = {
                    ...array[i],
                    rowIndex: i,
                    quantity: array[i].quantity,
                    picking: i == 0 ? i + 1 + 'st'
                        : i == 1 ? i + 1 + 'nd'
                            : i == 2 ? i + 1 + 'rd'
                                : i + 1 + 'th',
                    date: array[i].date
                }
                checkDateValue(array[i].date, i)
                checkQuntityValue(array[i].quantity, i)
            }
            setPickingData({
                ...pickingData,
                noOfPickings: array.length
            });
            setPickingTable(array);
            GenerateCropForcast(array);
        }
        else {
            toast.error("One or more pickings should need");
        }
    }

    function changeText(e, rowID, inputType) {
        const target = e.target;
        const value = target.value
        const newArr = [...pickingTable];
        var idx = newArr.findIndex(e => e.rowIndex == parseInt(rowID));

        if (inputType == "quantity") {
            checkQuntityValue(value, idx)
            newArr[idx] = { ...newArr[idx], quantity: value == "" ? parseInt(0) : parseFloat(value) };

        }
        else if (inputType == "date") {
            checkDateValue(value, idx)
            newArr[idx] = { ...newArr[idx], date: value == "" ? "" : value };
            // newArr.sort((a, b) => a.date > b.date ? 1 : -1);
            // for (let i = 0; i < newArr.length; i++) {
            //     newArr[i] = {
            //         ...newArr[i],
            //         rowIndex: i,
            //         quantity: newArr[i].quantity,
            //         picking: i == 0 ? i + 1 + 'st'
            //             : i == 1 ? i + 1 + 'nd'
            //                 : i == 2 ? i + 1 + 'rd'
            //                     : i + 1 + 'th',
            //         date: newArr[i].date
            //     }
            //     checkDateValue(newArr[i].date, i)
            //     checkQuntityValue(newArr[i].quantity, i)
            // }
        }
        setPickingTable(newArr);
        GenerateCropForcast(newArr);
    }

    function checkQuntityValue(value, id) {
        var pattern = /^[0-9]+([.][0-9]{0,2})?$/;

        var copyOfMaxErrMsgs = maxErrorMsg;
        var copyOfIsMaxEror = isMaxEror;

        copyOfIsMaxEror[id] = id;
        setIsMaxEror(copyOfIsMaxEror);

        if (value <= 0) {
            copyOfMaxErrMsgs[id] = "Quantity need to be a positive number.";
        } else if (value.length === 0) {
            copyOfMaxErrMsgs[id] = "Quantity cannot be empty.";
        } else if (!pattern.test(value.toString())) {
            copyOfMaxErrMsgs[id] = "Quantity only allow numbers.";
        } else {
            copyOfMaxErrMsgs[id] = "";

            copyOfIsMaxEror[id] = -1;
            setIsMaxEror(copyOfIsMaxEror);
        }
        setMaxErrorMsg(copyOfMaxErrMsgs);
    }

    function checkDateValue(value, id) {
        var copyOfMinErrMsgs = minErrorMsg;
        var copyOfIsMinEror = isMinEror;

        copyOfIsMinEror[id] = id;
        setIsMinEror(copyOfIsMinEror);

        if (value == "") {
            copyOfMinErrMsgs[id] = "Date required.";
        } else {
            copyOfMinErrMsgs[id] = "";

            copyOfIsMinEror[id] = -1;
            setIsMinEror(copyOfIsMinEror);
        }
        setMinErrorMsg(copyOfMinErrMsgs);
    }

    function GenerateCropForcast(res) {
        let found = res.filter(x => x.quantity == 0 || x.date == "");
        if (found.length == 0) {
            let result = [];
            res.forEach(x => {
                let model = {
                    cropID: parseInt(cropData.cropID),
                    productVarietyID: parseInt(cropData.productVarietyID),
                    cropForecastDate: x.date,
                    quantity: parseFloat(x.quantity),
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken())
                };
                result.push(model);
            });

            let totalYiald = 0;
            result.forEach(x => {
                totalYiald = totalYiald + parseFloat(x.quantity);
            });
            var last = result.slice(-1)[0];
            setCropData({
                ...cropData,
                date: result == undefined ? '' : result[0].cropForecastDate,
                startDate: result == undefined ? '' : result[0].cropForecastDate,
                endDate: last.cropForecastDate,
                yield: parseFloat(totalYiald).toFixed(2),
                noOfPikings: result.length,
            });
            setPikingsDetails(result)
        }
        setPickingTableError(found.length == 0 ? false : true)
    }

    return (
        <>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} width={263}>
                <TextField
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    name='noOfPickings'
                    variant="outlined"
                    label="No Of Pickings"
                    value={pickingData.noOfPickings}
                    onChange={(e) => { handlePickingChange(e) }}
                />
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }}>
                <Card style={{ justifycontent: 'center', width: '150rem' }} >
                    <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Pickings</TableCell>
                                    <TableCell align="center">Date</TableCell>
                                    <TableCell align="center">Quantity</TableCell>
                                    {pickingTable.length > 1 ?
                                        <TableCell align="center">Action</TableCell> : null}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pickingTable.map((object) => {
                                    let ID = object.rowIndex
                                    return (
                                        <TableRow >
                                            <TableCell align="center">
                                                {object.picking}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Grid alignContent={'center'}>
                                                    <TextField
                                                        style={{ width: '10rem' }}
                                                        variant="outlined"
                                                        size={"small"}
                                                        type='date'
                                                        value={object.date}
                                                        onChange={(e) => changeText(e, object.rowIndex, "date")}
                                                    />
                                                </Grid>
                                                {(parseInt(isMinEror[ID]) === parseInt(ID)) ?
                                                    <small style={{ color: 'red', wordWrap: 'break-word' }}>{minErrorMsg[ID]}</small> : null
                                                }
                                            </TableCell>
                                            <TableCell align="center">
                                                <Grid alignContent={'center'}>
                                                    <TextField
                                                        style={{ width: '7rem' }}
                                                        variant="outlined"
                                                        size={"small"}
                                                        name={ID}
                                                        InputProps={{
                                                            inputProps: {
                                                                step: 0.01,
                                                                type: 'number',
                                                            },
                                                        }}
                                                        onWheel={event => event.target.blur()}
                                                        onKeyDown={(evt) =>
                                                            (evt.key === "-") && evt.preventDefault()
                                                        }
                                                        onChange={(e) => changeText(e, object.rowIndex, "quantity")}
                                                        value={object.quantity}
                                                    />
                                                </Grid>
                                                {(parseInt(isMaxEror[ID]) === parseInt(ID)) ?
                                                    <small style={{ color: 'red', wordWrap: 'break-word' }}>{maxErrorMsg[ID]}</small> : null
                                                }
                                            </TableCell>
                                            <TableCell align="center">
                                                {pickingTable.length > 1 ?
                                                    <IconButton aria-label="delete" onClick={(e) => handleDelete(e, object.rowIndex)} >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                    : null}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
                <br />
            </Stack>
        </>
    );
}